<div class="mb-3" [class.invalid-feedback]="showError">
  @if (props.label && props.hideLabel !== true) {
    <label [attr.for]="id"> {{ props.label }}@if (props.required && props.hideRequiredMarker !== true) {
      <span>*</span>
    } </label>
  }

  <div style="display: flex">
    <tui-textfield [tuiTextfieldCleaner]="false" tuiTextfieldSize="s" style="width: 100%; max-width: 300px">
      @if (!formControl.value) {
        <label tuiLabel i18n="@@VyberiteDatu">Выберите дату</label>
      }
      <input tuiInputDate [(ngModel)]="value" [formlyAttributes]="field" autocomplete="off" [disabled]="props.readonly"/>
      <tui-calendar *tuiDropdown/>
    </tui-textfield>

    @if (hasValue && !props.readonly) {
      <button nbButton size="small" status="control" (click)="clear()" type="button">
        <tui-icon icon="x"/>
      </button>
    }
  </div>

  @if (showError) {
    <div class="invalid-feedback">
      <formly-validation-message [field]="field" />
    </div>
  }
  @if (props.description) {
    <small class="form-text text-muted">{{ props.description }}</small>
  }
</div>
